import React from "react";
import Datetime from "react-datetime";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import {makeStyles} from "@material-ui/styles";
import FormHelperText from "@material-ui/core/FormHelperText";
import classNames from "classnames";

import customInputStyle from "../../../material-dashboard/assets/jss/components/customInputStyle.jsx";
import {useFormField} from "../../useFormField";
import moment from "moment";

const useStyles = makeStyles(customInputStyle);

const onChange = (ff, value) => {
    // when the value is string it is invalid according to moment, but it might be righ
    if (typeof value === 'string') {
        const v2 = moment(value, ['YYYY-MM-DD', 'YYYY.MM.DD', 'YYYY.MM.DD.', 'YYYY/MM/DD'], true)
        if (v2.isValid()) {
            ff.onChange(v2.format("YYYY-MM-DD"));
        } else {
            ff.onChange(value);
        }
        return
    }

    ff.onChange(value.format("YYYY-MM-DD"));
};

function ValidatedDate(props) {
    const {disabled} = props;

    const classes = useStyles();

    const ff = useFormField(props, classes);

    const labelClasses = classNames(classes.labelRoot, {
        [classes.labelRootError]: ff.status === "invalid",
        [classes.labelRootSuccess]: ff.status === "valid"
    });

    const datetimeClasses = classNames({
        [classes.input]: true,
        [classes.whiteInput]: false,
        [classes.disabled]: disabled,
        [classes.underlineError]: ff.status === "invalid",
        [classes.underlineSuccess]: ff.status === "valid",
        [classes.underline]: true,
        [classes.whiteUnderline]: false
    });

    const formControlClasses = classes.formControl;

    let helpTextClasses = classNames({
        [classes.labelRootError]: ff.status === "invalid",
        [classes.labelRootSuccess]: ff.status === "valid"
    });

    return (
        <FormControl className={formControlClasses} fullWidth>
            <InputLabel
                className={labelClasses}
                shrink={ff.value !== undefined && ff.value !== ''}
                htmlFor={ff.id}>
                {ff.labelText}
            </InputLabel>
            <Datetime
                id={ff.id}
                classNames={datetimeClasses}
                inputProps={{
                    className: "form-control " + classes.dateTimeInput,
                    disabled: ff.disabled
                }}
                dateFormat={"YYYY.MM.DD"}
                timeFormat={false}
                value={ff.value == null ? ff.value : ff.value.replaceAll("-", ".")}
                closeOnSelect={true}
                onChange={(v) => onChange(ff, v)}
            />
            {ff.helperText ?
                <FormHelperText id={ff.id + "-text"} className={helpTextClasses}>
                    {ff.helperText}
                </FormHelperText>
                : null}
        </FormControl>
    );
}

export default ValidatedDate;